import { diaryActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
    selectedMessage: undefined,
    loading: false,
    resolveVisible: false
};

export const reducer = createReducer(initialState, {
    [diaryActions.setSelectedMessage]: (state, action) => {
        state.selectedMessage = action.payload.dlno;
        state.resolveVisible = false;
    },
    [diaryActions.markReadFailure]: (state, action) => {
        log.error('Error marking message as read. dlno: ' + action.payload.dlno + ' error: ' + action.payload.error);
    },
    [diaryActions.loadRequest]: (state, action) => {
        state.loading = true;
    },
    [diaryActions.loadSuccess]: (state, action) => {
        state.loading = false;
    },
    [diaryActions.loadFailure]: (state, action) => {
        state.loading = false;
        log.error('Error loading diary items. error: ' + action.payload.error);
    },
    [diaryActions.resolveSuccess]: (state, action) => {
        state.selectedMessage = undefined;
        state.resolveVisible = false;
    },
    [diaryActions.resolveFailure]: (state, action) => {
        log.error('Error resolving dlno: ' + action.payload.dlno + ' error: ' + action.payload.error);
    },
    [diaryActions.toggleResolve]: (state, action) => {
        state.resolveVisible = !state.resolveVisible;
    }

   
})


